import { render, staticRenderFns } from "./HotKeyWord.vue?vue&type=template&id=1d112872&scoped=true&"
import script from "./HotKeyWord.vue?vue&type=script&lang=js&"
export * from "./HotKeyWord.vue?vue&type=script&lang=js&"
import style0 from "./HotKeyWord.vue?vue&type=style&index=0&id=1d112872&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d112872",
  null
  
)

export default component.exports